import { render } from "./ApplicationWebDesktop.vue?vue&type=template&id=3d164bf0"
import script from "./ApplicationWebDesktop.vue?vue&type=script&lang=js"
export * from "./ApplicationWebDesktop.vue?vue&type=script&lang=js"

import "./ApplicationWebDesktop.vue?vue&type=style&index=0&id=3d164bf0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__